/*@ngInject*/
const QuoteActionUtil = function ($rootScope, $state, $uibModal, $q, coreConstant, breadcrumbsMediator, quoteTransition, submissionConstant, submissionMediator, coreMediator,
                                  modalUtil, umModalUtil, uiPerformanceLoggerConstant, currentSubmissionModel, agentQuoteStatus, loadingBarHandler, quoteMediator,
                                  proposalMediator, quoteActionsMediator, actionsMediator, attachmentUtil, collaborationMediator, sectionType, quoteStatus) {

    this.deleteQuote = function (quoteId, submissionId) {
        modalUtil.showConfirmationModal(submissionId, quoteId, null/*notificationName*/, 'submission.wizard.deleteQuoteModal',
            null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {

            function onSuccess() {
                var deleteQuoteAction = uiPerformanceLoggerConstant.DELETE_QUOTE,
                    deleteQuoteStatus = coreConstant.uiPeformanceLogger.SUCCESS;
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, deleteQuoteAction, deleteQuoteStatus);
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
            }

            function onError() {
                var action = uiPerformanceLoggerConstant.DELETE_QUOTE,
                    status = coreConstant.uiPeformanceLogger.FAIL;
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
            }

            let logAction = uiPerformanceLoggerConstant.DELETE_QUOTE,
                message = quoteId.toString(),
                promise;
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);

            promise = quoteActionsMediator.deleteQuote(quoteId).then(onSuccess, onError);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;

        }
    };

    this.copyQuoteForMultiQuoteProposal = function (quoteId, submissionId) {
        function onSuccess() {
            var copyQuoteAction = uiPerformanceLoggerConstant.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL,
                copyQuoteStatus = coreConstant.uiPeformanceLogger.SUCCESS;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, copyQuoteAction, copyQuoteStatus);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        }

        function onError() {
            var action = uiPerformanceLoggerConstant.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL,
                status = coreConstant.uiPeformanceLogger.FAIL;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
        }

        loadingBarHandler.showLoadingBar('submission.wizard.copyQuote.loadingBar');

        return quoteMediator.getQuote(quoteId).then(function (quote) {
            var proposalId = quote.proposalId,
                promise;

            $rootScope.$broadcast(
                coreConstant.event.START_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL,
                proposalId.toString()
            );

            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = quoteActionsMediator.copyQuote(quoteId, proposalId).then(onSuccess, onError);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        });
    };

    this.copyQuote = function (quoteId, submissionId) {
        function onSuccess() {
            var copyQuoteAction = uiPerformanceLoggerConstant.COPY_QUOTE,
                copyQuoteStatus = coreConstant.uiPeformanceLogger.SUCCESS;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, copyQuoteAction, copyQuoteStatus);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        }

        function onError() {
            var action = uiPerformanceLoggerConstant.COPY_QUOTE,
                status = coreConstant.uiPeformanceLogger.FAIL;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
        }

        loadingBarHandler.showLoadingBar('submission.wizard.copyQuote.loadingBar');

        var logAction = uiPerformanceLoggerConstant.COPY_QUOTE,
            message = quoteId.toString(),
            promise;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = quoteActionsMediator.copyQuote(quoteId).then(onSuccess, onError);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.handleDeclineToBind = function (quoteId, submissionId) {
        umModalUtil.showReasonModal(submissionId, quoteId, null/*notificationName*/, null/*reasonObject*/, 'submission.wizard.reasonModal.declineToBindModal',
            true/*isReasonOptional*/, uiPerformanceLoggerConstant.DECLINE_TO_BIND, handleClose);

        function handleClose(result) {
            let promise = quoteActionsMediator.declineToBind(quoteId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.requestBinding = function (quoteId, submissionId) {
        modalUtil.showConfirmationModal(submissionId, quoteId, null/*notificationName*/, 'submission.wizard.requestBindingModal',
            null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            function onSuccess(response) {
                if (currentSubmissionModel.getCurrentSubmission().agentQuoteStatus === agentQuoteStatus.DISABLED) {
                    var requestBindingAction = uiPerformanceLoggerConstant.REQUEST_BINDING,
                        requestBindingStatus = coreConstant.uiPeformanceLogger.SUCCESS;
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, requestBindingAction, requestBindingStatus);
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                }
            }

            function onError() {
                let action = uiPerformanceLoggerConstant.REQUEST_BINDING,
                    status = coreConstant.uiPeformanceLogger.FAIL;
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
            }

            let logAction = uiPerformanceLoggerConstant.REQUEST_BINDING,
                message = quoteId.toString(),
                promise;
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);

            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = quoteActionsMediator.requestBinding(quoteId).then(onSuccess, onError);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.generateQuote = function (quoteId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.generatingQuote');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = quoteActionsMediator.generateQuote(quoteId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyQuote = function (quoteId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyingQuote');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = quoteActionsMediator.modifyQuote(quoteId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    function populateBreadcrumb(quoteSummary) {
        return breadcrumbsMediator.loadQuoteBreadcrumbs(quoteSummary.id).then(function (breadcrumbs) {
            quoteSummary.breadcrumb = breadcrumbs;
        });
    }

    function openQuoteSelectionModal(quoteId, transition) {
        let quoteSummaries = [],
            promises = [];
        return quoteActionsMediator.getQuotesWithEnabledAction(quoteId, transition).then((quotesMap) => {
            let quoteStatus;
            _.each(quotesMap.enabled, function (quoteSummary) {
                quoteSummary.actionEnabled = true;
                quoteSummary.isSelected = true;
                quoteSummaries.push(quoteSummary);
                quoteStatus = quoteSummary.status;
            });
            _.each(quotesMap.valid, function (quoteSummary) {
                quoteSummary.incomplete = true;
                quoteSummary.isSelected = false;
                quoteSummaries.push(quoteSummary);
            });
            _.each(quotesMap.invalid, function (quoteSummary) {
                quoteSummary.isSelected = false;
                quoteSummaries.push(quoteSummary);
            });

            quoteSummaries = _.orderBy(quoteSummaries, ['status', 'incomplete', 'summary'], ['asc', 'desc', 'asc']);

            if (quotesMap.enabled.length + quotesMap.valid.length + quotesMap.invalid.length === 1) {
                return $q.resolve({result: $q.resolve({quoteIds: quoteId})});
            }

            _.each(quoteSummaries, function (quoteSummary) {
                promises.push(populateBreadcrumb(quoteSummary));
            });

            return $q.all(promises).then(() => {
                loadingBarHandler.hideLoadingBar();
                return $uibModal.open({
                    templateUrl: '/wizard/quoteSelection/quoteSelectionModal.tpl.html',
                    controller: 'quoteSelectionModalController',
                    backdrop: 'static',
                    windowClass: 'quoteSelectionModal',
                    resolve: {
                        options: () => {
                            return {
                                quoteSummaries: quoteSummaries,
                                transition: transition
                            };
                        }
                    }
                });
            });
        });

    }

    this.startQuote = function (quoteId, submissionId) {
        let promise;

        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.START_QUOTE, submissionId);
        loadingBarHandler.showLoadingBar('submission.startingQuote');
        return openQuoteSelectionModal(quoteId, quoteTransition.START_QUOTE).then((modalInstance) => {
            return modalInstance.result.then((result) => {
                loadingBarHandler.showLoadingBar('submission.startingQuote');

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                let onSuccess = () => {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

                    loadingBarHandler.hideLoadingBar();
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.START_QUOTE, coreConstant.uiPeformanceLogger.SUCCESS);
                };

                let onFailure = () => {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.START_QUOTE, coreConstant.uiPeformanceLogger.FAIL);
                };

                promise = quoteActionsMediator.startQuote(result.quoteIds).then(onSuccess, onFailure);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        });


    };

    this.generateRating = function (quoteId) {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, quoteId);
        loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
        return openQuoteSelectionModal(quoteId, quoteTransition.GENERATE_RATING).then((modalInstance) => {
            return modalInstance.result.then((result) => {
                loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                let onSuccess = () => {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

                    loadingBarHandler.hideLoadingBar();
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, coreConstant.uiPeformanceLogger.SUCCESS);
                };

                let onFailure = () => {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, coreConstant.uiPeformanceLogger.FAIL);
                };

                const promise = quoteActionsMediator.generateRating(result.quoteIds).then(onSuccess, onFailure);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        });
    };

    this.startPricing = function (quoteId) {
        loadingBarHandler.showLoadingBar('submission.startPricing');
        return openQuoteSelectionModal(quoteId, quoteTransition.START_PRICING).then((modalInstance) => {
            return modalInstance.result.then((result) => {
                let promise;
                loadingBarHandler.showLoadingBar('submission.startPricing');

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                promise = quoteActionsMediator.startPricing(result.quoteIds).then(() => {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

                    loadingBarHandler.hideLoadingBar();
                });
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        });
    };

    this.refreshQuoteByIds = function (quoteIds) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.refreshQuote');

        promise = quoteActionsMediator.refreshQuoteByIds(quoteIds).finally(function () {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyPricing = function (quoteId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyPricing');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = quoteActionsMediator.modifyPricing(quoteId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyRating = function (quoteId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyingRating');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = quoteActionsMediator.modifyRating(quoteId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.sendProposal = function (quoteId, submissionId) {
        modalUtil.showConfirmationModal(
            null/*submissionId*/,
            null/*quoteId*/,
            null/*notificationName*/,
            'submission.wizard.sendProposalModal',
            null/*performanceLoggerName*/,
            /*hideLoadingBar*/false,
            handleClose);

        function handleClose() {
            function onSuccess(response) {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.SEND_PROPOSAL,
                    coreConstant.uiPeformanceLogger.SUCCESS
                );
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            }

            function onError() {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.SEND_PROPOSAL,
                    coreConstant.uiPeformanceLogger.FAIL
                );
            }

            return quoteMediator.getQuote(quoteId).then(function (quote) {
                var proposalId = quote.proposalId,
                    promise;

                $rootScope.$broadcast(
                    coreConstant.event.START_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.SEND_PROPOSAL,
                    proposalId.toString()
                );

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                promise = proposalMediator.sendProposal(proposalId).then(onSuccess, onError);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        }
    };

    this.bindQuote = function (quoteId, submissionId) {
        modalUtil.showConfirmationModal(
            submissionId,
            quoteId,
            null/*notificationName*/,
            'submission.wizard.bindModal',
            null,
            /*hideLoadingBar*/false,
            handleClose);

        function handleClose() {
            function onSuccess(response) {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.BIND,
                    coreConstant.uiPeformanceLogger.SUCCESS
                );
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            }

            function onError() {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.BIND,
                    coreConstant.uiPeformanceLogger.FAIL
                );
            }

            return quoteMediator.getQuote(quoteId).then(function (quote) {
                var proposalId = quote.proposalId,
                    promise;

                $rootScope.$broadcast(
                    coreConstant.event.START_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.BIND,
                    proposalId.toString()
                );

                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                promise = quoteActionsMediator.bindQuote(proposalId).then(onSuccess, onError);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        }
    };

    this.generateBinder = function (quoteId, submissionId) {
        function onSuccess(response) {
            $rootScope.$broadcast(
                coreConstant.event.END_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.GENERATE_BINDER,
                coreConstant.uiPeformanceLogger.SUCCESS
            );
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        }

        function onError() {
            var action = uiPerformanceLoggerConstant.GENERATE_BINDER,
                status = coreConstant.uiPeformanceLogger.FAIL;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status);
        }

        var logAction = uiPerformanceLoggerConstant.GENERATE_BINDER,
            message = quoteId.toString(),
            quoteIds = [quoteId],
            promise;

        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = quoteActionsMediator.generateBinder(quoteIds).then(onSuccess, onError);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.beginBinding = function (quoteId, submissionId) {
        loadingBarHandler.showLoadingBar('submission.beginBinding');

        function onSuccess(response) {
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BEGIN_BINDING, coreConstant.uiPeformanceLogger.SUCCESS);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BEGIN_BINDING, coreConstant.uiPeformanceLogger.FAIL);
        }

        function onFinally() {
            loadingBarHandler.hideLoadingBar();
        }

        var promise;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.BEGIN_BINDING, submissionId);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = quoteActionsMediator.beginBinding(quoteId).then(onSuccess, onError).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.getQuotableProductTemplates = function (submissionId) {
        let promise;

        function onSuccess(response) {
            if (response.length === 1) {
                createQuote(submissionId, [response[0].id]);
            } else if (response.length > 1) {
                var modalInstance = $uibModal.open({
                    templateUrl: '/wizard/quotableProductTemplates/quotableProductTemplatesModal.tpl.html',
                    controller: 'quotableProductTemplatesModalController',
                    backdrop: 'static',
                    windowClass: 'quotableProductModal',
                    resolve: {
                        options: function () {
                            return {
                                quotableProducts: response,
                                isProposalAction: false
                            };
                        }
                    }
                });

                modalInstance.result.then(function (options) {
                    createQuote(submissionId, options.selectedQuotableProductId);
                });
            }
        }

        promise = actionsMediator.getQuotableProductTemplates(submissionId).then(onSuccess);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.addQuoteDocument = function (submissionId, quoteId) {
        var modalInstance;

        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingAttachments');

        collaborationMediator.loadSubmissionAttachments(submissionId).then(function (submissionAttachmentList) {
            loadingBarHandler.hideLoadingBar();

            submissionAttachmentList = _.toArray(submissionAttachmentList);
            if (submissionAttachmentList.length > 0) {
                modalInstance = modalUtil.showAttachmentsListModal(submissionAttachmentList);
            } else {
                modalInstance = modalUtil.showNewAttachmentModal();
            }

            modalInstance.then(function (data) {
                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
                if (attachmentUtil.isNewAttachmentObject(data)) {
                    addSectionFromFile(data, quoteId);
                } else {
                    addSectionFromDocument(data, quoteId);
                }
            });
        }).finally(function () {
            loadingBarHandler.hideLoadingBar();
        });
    };

    function addSectionFromFile(data, quoteId) {
        var attachment = data.attachment,
            file = data.file,
            payload = attachmentUtil.getAttachmentPayload(attachment),
            promise;

        //save attachment
        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.uploading');

        promise = quoteActionsMediator.addSectionFromFile(quoteId, payload, file).finally(function () {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    }

    function addSectionFromDocument(attachment, quoteId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingBar');

        promise = quoteActionsMediator.addSectionFromDocument(quoteId, attachment.id, attachment.description).finally(function () {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    }

    function createQuote(submissionId, selectedQuotableProductId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = actionsMediator.createQuote(submissionId, selectedQuotableProductId).then(function (response) {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    }

    this.unbind = function (quoteId, submissionId) {
        function handleClose(result) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = quoteActionsMediator.unbind(quoteId, result.reason, result.details)
                .then(function () {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                })
                .finally(function () {
                    loadingBarHandler.hideLoadingBar();
                });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            quoteId,
            null/*removed'notification.unbind'*/,
            null/*reason*/,
            'submission.wizard.reasonModal.unbindModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.UNBIND,
            handleClose);
    };

    this.modifyBinder = function (quoteId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.wizard.modifyBinder.loadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        function onSuccess(response) {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        }

        function onFinally() {
            loadingBarHandler.hideLoadingBar();
        }

        promise = quoteActionsMediator.modifyBinder(quoteId).then(onSuccess).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.addSection = function (quoteId, submissionId) {
        modalUtil.showSelectionModal(submissionId, quoteId, null, 'submission.wizard.selectionModal.addSectionModal',
            uiPerformanceLoggerConstant.ADD_SECTION, handleClose);

        function handleClose(sectionTemplateId) {
            let promise = quoteActionsMediator.addSection(quoteId, sectionTemplateId, sectionType.PROPOSAL);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.deleteSection = function (quoteId, submissionId) {
        modalUtil.showSelectionModal(submissionId, quoteId, null, 'submission.wizard.selectionModal.deleteSectionModal',
            uiPerformanceLoggerConstant.DELETE_SECTION, handleClose);

        function handleClose(sectionTemplateId) {
            let promise = quoteActionsMediator.deleteSection(sectionTemplateId, /*invalidateProposalDocument*/true);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.generateRatingAttachments = function (quoteId, submissionId) {
        var dynamicDataSetParams = {
            name: 'Rating Attachment Groups',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
            ownerUri: 'com.firstbest.underwriting.quote.Quote:' + quoteId
        };

        function onSuccess(response) {
            var ratingAttachmentGroups = {};

            // Format the response into a mapping of the separate attachment groups, for easier processing in the modal.
            _.each(response, function (dataItem) {
                if (!ratingAttachmentGroups[dataItem.grouping]) {
                    ratingAttachmentGroups[dataItem.grouping] = {
                        name: dataItem.grouping,
                        ratingAttachments: []
                    };
                }

                ratingAttachmentGroups[dataItem.grouping].ratingAttachments.push(dataItem);
            });

            $uibModal.open({
                templateUrl: '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html',
                controller: 'generateRatingAttachmentsModalController',
                backdrop: 'static',
                windowClass: 'generateRatingAttachmentsModalContainer',
                resolve: {
                    options: function () {
                        return {
                            ratingAttachmentGroups: ratingAttachmentGroups
                        };
                    }
                }
            }).result.then(function (options) {
                var action = uiPerformanceLoggerConstant.GENERATE_RATING_ATTACHMENTS,
                    message = quoteId.toString(),
                    promise;

                function onSuccess() {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
                }

                function onFinally() {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    loadingBarHandler.hideLoadingBar();
                }

                loadingBarHandler.showLoadingBar('submission.wizard.generateRatingAttachments.loadingBar');
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                promise = quoteActionsMediator.generateRatingAttachments(quoteId, options.selectedRatingAttachments).then(onSuccess, onError).finally(onFinally);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        }

        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(onSuccess);
    };

    this.revertToSent = function (quoteId, submissionId) {
        modalUtil.showConfirmationModal(submissionId, quoteId, null/* notificationName */, 'submission.wizard.revertToSentModal',
            uiPerformanceLoggerConstant.REVERT_TO_SENT, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = quoteActionsMediator.revertToSent(quoteId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.withdrawQuote = function (quoteId, submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notificationName*/, null /*reason*/,
            'submission.wizard.reasonModal.withdrawQuoteModal', false, uiPerformanceLoggerConstant.WITHDRAW_QUOTE, handleClose);

        function handleClose(result) {
            let promise = quoteActionsMediator.withdrawQuote(quoteId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.withdrawRequest = function (quoteId, submissionId) {
        modalUtil.showConfirmationModal(submissionId, quoteId, /*notificationName*/null, 'submission.wizard.withdrawRequestModal',
            uiPerformanceLoggerConstant.WITHDRAW_REQUEST, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = quoteActionsMediator.withdrawRequest(quoteId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };
};

angular.module('gw-um-submission')
    .service('quoteActionUtil', QuoteActionUtil);
